import { Phone, MessageCircle, MapPin } from "lucide-react";
import { business } from "@/config/business";
import { buildWhatsAppUrl, generalMessage } from "@/lib/whatsapp";

// Mobile bottom action bar + desktop floating WhatsApp button.
export const MobileActionBar = () => (
  <>
    <nav
      className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-3 border-t border-border bg-[hsl(var(--paper))]/95 backdrop-blur-xl lg:hidden"
      aria-label="Quick actions"
      data-testid="mobile-action-bar"
    >
      <a href={`tel:${business.phone}`} data-testid="action-call" className="flex flex-col items-center gap-0.5 py-2.5 text-xs font-medium">
        <Phone className="h-5 w-5" /> Call
      </a>
      <a href={buildWhatsAppUrl(generalMessage())} target="_blank" rel="noopener noreferrer" data-testid="action-whatsapp" className="flex flex-col items-center gap-0.5 border-x border-border py-2.5 text-xs font-semibold text-[hsl(var(--accent))]">
        <MessageCircle className="h-5 w-5" /> WhatsApp
      </a>
      <a href={business.googleDirectionsUrl} target="_blank" rel="noopener noreferrer" data-testid="action-directions" className="flex flex-col items-center gap-0.5 py-2.5 text-xs font-medium">
        <MapPin className="h-5 w-5" /> Directions
      </a>
    </nav>

    <a
      href={buildWhatsAppUrl(generalMessage())}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-40 hidden h-14 w-14 items-center justify-center rounded-full bg-[hsl(var(--accent))] text-white shadow-lg shadow-black/20 transition-transform hover:scale-110 lg:flex"
    >
      <MessageCircle className="h-6 w-6" />
    </a>
  </>
);
